import React from "react";
import { TableRowProps } from "../../molecules/TableRow/TableRowAtom";
import {
  createInfoCell,
  createClickableCell,
} from "../../utilities/CreateCell";
import { createRow } from "../../utilities/CreateRow";

type RowActionHandlers = {
  setOpenEdit: React.Dispatch<React.SetStateAction<boolean>>;
  setSelected: React.Dispatch<any>;
  acceptMutate: (id: number) => void;
  replaceMutate: (id: number) => void;
  requestDelete: (id: number) => void;
  loadingAction: { type: "accept" | "replace" | "delete"; id: number } | null;
};

export const createTemporaryNdcRows = (
  data: any[] | undefined,
  handlers: RowActionHandlers,
) => {
  if (!data) return [];

  const {
    setOpenEdit,
    setSelected,
    acceptMutate,
    replaceMutate,
    requestDelete,
    loadingAction,
  } = handlers;

  const rows: TableRowProps[] = [];

  data.forEach((entry) => {
    const isAcceptLoading =
      loadingAction?.type === "accept" && loadingAction.id === entry.id;
    const isReplaceLoading =
      loadingAction?.type === "replace" && loadingAction.id === entry.id;
    const isDeleteLoading =
      loadingAction?.type === "delete" && loadingAction.id === entry.id;

    const strengthDisplay = [entry.strength, entry.strengthUom]
      .filter((s) => s != null && String(s).trim() !== "")
      .join(" ");

    rows.push(
      createRow(
        createInfoCell(entry.ndc),
        createInfoCell(entry.drugName),
        createInfoCell(strengthDisplay || ""),
        createInfoCell(entry.dosageForm),
        createInfoCell(entry.packageSize),
        createInfoCell(entry.packageQuantity),
        createInfoCell(entry.manufacturer),
        createInfoCell(entry.controlledSubstanceCode),
        createInfoCell(entry.packagePrice),
        createInfoCell(entry.unitPrice),
        createInfoCell(entry.packageActualPrice),
        createInfoCell(entry.unitActualPrice),

        createInfoCell(
          entry.existsInMedispan ? "Exists in MediSpan" : "Temporary",
        ),

        createClickableCell(() => {
          setSelected(entry);
          setOpenEdit(true);
        }, "Edit"),

        entry.existsInMedispan
          ? createClickableCell(
              () => replaceMutate(entry.id),
              isReplaceLoading ? "Replacing..." : "Replace",
            )
          : createClickableCell(
              () => acceptMutate(entry.id),
              isAcceptLoading ? "Accepting..." : "Accept",
            ),

        createClickableCell(
          () => requestDelete(entry.id),
          isDeleteLoading ? "Deleting..." : "Remove",
        ),
      ),
    );
  });

  return rows;
};
